// The three drifting orbs and the looping site video, both purely decorative.
export function Backdrop() {
  return (
    <>
      <div className="orb orb-1" />
      <div className="orb orb-2" />
      <div className="orb orb-3" />
      <video className="site-video-bg" autoPlay muted loop playsInline>
        <source src="/movie/11.mp4" type="video/mp4" />
      </video>
      <div className="site-video-overlay" />
    </>
  );
}
